import type { Node, NodeProps } from '@xyflow/react';
import { PaperAirplaneIcon } from '@heroicons/react/24/outline';
import { nodeLabel } from '../graphModel';
import { chevronProps, type FlowNodeData } from '../useGraphLayout';
import { KIND_PALETTE } from '../kindPalette';
import { MentionCount } from './MentionCount';
import { NodeShell } from './NodeShell';

export function AircraftNode({ data }: NodeProps<Node<FlowNodeData>>) {
  if (data.node.kind !== 'aircraft') return null;
  return (
    <NodeShell
      icon={PaperAirplaneIcon}
      iconClassName="text-sky-600 dark:text-sky-400"
      compactClassName={KIND_PALETTE.aircraft.compact}
      label={nodeLabel(data.node)}
      selected={data.selected}
      focused={data.focused}
      {...chevronProps(data)}
      className="w-40"
    >
      {/* One line only, so the count sits beside the registration. */}
      <div className="flex items-center gap-2">
        <span className="min-w-0 truncate text-sm font-medium">{data.node.registration}</span>
        <MentionCount count={data.mentions} />
      </div>
    </NodeShell>
  );
}
